import { inputRichTextCommands } from '@dixa/lib-shared-habla';

import { presenceActions } from 'components/presence/actions/presenceActions';
import {
  createCommand,
  createCommands,
  useCommandHandler,
} from 'utils/commands';
import { camelToSentenceCase } from 'utils/formatting/string';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { appActions } from './app.actions';

const { presenceSetStatus } = presenceActions;

export const globalCommands = createCommands([
  {
    group: 'app',
    label: 'Keyboard shortcuts cheat sheet',
    name: 'keyboardCheatSheet',
    description: 'Toggles the keyboard shortcuts cheat sheet',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl'], 'Slash'] }],
      isNonRebindable: true,
    },
    useRegisterHandler: () => {
      const dispatch = useAppDispatch();

      useCommandHandler({
        name: 'app:keyboardCheatSheet',
        actionFn: () => {
          dispatch(
            appActions.showModal({ modal: { type: 'app:keyboardCheatSheet' } }),
          );
        },
      });
    },
  },
  {
    group: 'app',
    label: 'Open dialer',
    name: 'openDialer',
    description: 'Opens the phone dialer',
    keyboard: { keybindings: [{ binding: [['$metaOrCtrl', 'Alt'], 'KeyP'] }] },
  },
  {
    group: 'app',
    label: 'Toggle presence',
    name: 'togglePresence',
    description: 'Toggles presence between working and away',
    keyboard: {
      keybindings_mac: [{ binding: [['Meta', 'Control', 'Shift'], 'Tab'] }],
      keybindings_pc: [{ binding: [['Control', 'Alt'], 'Backquote'] }],
    },
    useRegisterHandler: () => {
      const dispatch = useAppDispatch();
      const presence = useAppSelector((state) => state.presence.presence);

      useCommandHandler({
        name: 'app:togglePresence',
        actionFn: () => {
          const newStatus = presence.status === 'working' ? 'away' : 'working';

          dispatch(presenceSetStatus({ status: newStatus }));
        },
      });
    },
  },
]);

/**
 * Represents the rich text editor commands.
 *
 * @remarks
 *   These commands are considered external and should not be handled internally
 *   by the RichTextEditor.
 */
export const richTextEditorCommands = [
  ...createCommands([
    {
      group: 'richTextEditor',
      name: 'send',
      label: 'Send message',
      isExternal: true,
      keyboard: {
        keybindings: [
          {
            binding: [['$metaOrCtrl'], 'Enter'],
          },
        ],
        isNonRebindable: true,
      },
    },
  ]),
  ...inputRichTextCommands.map((command) => {
    const { name, keybindings: bindings } = command;
    const keybindings = bindings.map((binding) => ({
      binding,
    }));

    return createCommand({
      group: 'richTextEditor',
      name,
      label: 'label' in command ? command.label : camelToSentenceCase(name),
      isExternal: true,
      keyboard: { keybindings },
    });
  }),
];
